module.exports = __webpack_public_path__ + "87b391fa2b064d199291d12a0ba017f1.jpg";